export default __webpack_public_path__ + "static/media/BABYCAKE.be34fd3a.svg";